// NOTE: use this function everytime you use a label to translate inside a .ts
// without call translateService
// it's needed by the translate extractor to generate the json
// e.g. const title = bitfToTranslate('COMMON.TITLE')
export function bitfToTranslate(str: string) {
  return str;
}
